import { useEffect, useState } from "react";
import { blcfacilitypagedata } from "../../Blc_Api/BlcFacilityPageData/BlcFacilityPageData";



// export function  useLocationPageData() {

//     const [locationData, setLocationData] = useState();

//     useEffect(()=>{
//         locationPageData().then(val =>{
//             setLocationData(val);
            
//         })

        
//     },[]);
   
//     return[locationData,setLocationData];
    
// }


export function  useBlcFacilityPageData() {

    const [facilityData,setFacilityData] = useState();

    useEffect(()=>{
        blcfacilitypagedata().then(val=>{
            setFacilityData(val);
        })
    },[])

    return [facilityData,setFacilityData];
    
}